import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { contractData } from "../types/uploadContract";

export const fetchContracts = async (): Promise<ApiResponse<contractData[]>> => {
  return apiClient<ApiResponse<contractData[]>>('/v1/contratos', {
    method: "GET"
  });
};
